//https://sso.dev.teamedio.de/auth/realms/comjoo-hub/protocol/openid-connect/certs

import KeycloakInfo from "../components/KeycloakInfo";

export default function Infos() {
  return <>
    <h2>Infos</h2>
    <KeycloakInfo />
  </>
}